<section class="mt-2">
    <seleccionar-financiador [paciente]="paciente" editable="true" (setFinanciador)="setFinanciador($event)">
    </seleccionar-financiador>
</section>